import React from 'react';
import ReactDOM from 'react-dom';
import { Amplify } from 'aws-amplify';

import { amplifyV6Config } from './amplify-v6-config';
import configureServices from './configure-services';
import './core/styles.css';
import App from './core/components/app';

Amplify.configure(amplifyV6Config);
configureServices();

ReactDOM.render(<App />, document.getElementById('root'));
